import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { isMobileMedia } from 'utils/media';

const styles = theme => ({
  root: {
    fontFamily: 'Circular',
    textDecoration: 'none',
    width: 'auto',
    maxWidth: isMobileMedia() ? '160px' : '200px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textAlign: 'left',
    '&:hover': {
      textDecoration: 'none'
    }
  }
});

const FulfillmentInformation = ({
  title,
  info,
  onClick,
  classes,
  dataTestId
}) => (
  <div style={{ display: 'inline-block', marginTop: '8px' }}>
    <Typography>{title}</Typography>
    {onClick ? (
      <Link
        classes={classes}
        component="button"
        variant="h4"
        data-testid={dataTestId}
        onClick={onClick}
      >
        {info}
      </Link>
    ) : (
      <Typography variant="h4">{info}</Typography>
    )}
  </div>
);

FulfillmentInformation.propTypes = {
  title: PropTypes.string.isRequired,
  info: PropTypes.string.isRequired,
  dataTestId: PropTypes.string,
  onClick: PropTypes.func,
  classes: PropTypes.object
};

export default withStyles(styles)(FulfillmentInformation);
